<div [tooltip]="title">
  <i class="s" *ngFor="let style of styles" [ngStyle]="style.s">
    <b class="b" [ngStyle]="style.b"></b>
    <b class="a" [ngStyle]="style.a"></b>
  </i>
</div>
